module.exports = __webpack_public_path__ + "img/idcard.7eca8a39.png";